import Toast from "components/toast";
import api from "services/axiosInstance";

export const UploadService = async (
  file: File,
  type: string = "image",
  isPublic: boolean = true,
  returnUrl: boolean = false
) => {
  let id = "";
  let url = "";
  try {
    if (!file) throw new Error("Image file is missing!");
    const data = new FormData();
    data.append("file", file);
    data.append("type", type);
    data.append("isPublic", isPublic ? "true" : "false");

    const res = await api.post("/storage/upload", data);

    id = res.data.id;
    url = res.data.url;
  } catch (e) {
    Toast({ error: e });
  } finally {
    return returnUrl ? url : id;
  }
};
